import { useState } from "react"
import { TextHighlighter } from "./textHighlighter"

const Seemore = (props) => {
    const [showall, setShowall] = useState(false)

    let toMatch = Array.isArray(props.person_name)
        ? props.person_name
        : [props.person_name]

    if (props.searchTerm)
        toMatch = {
            ...toMatch,
            toMatchText: props.searchTerm,
            highlightCustomStyle: {
                background: "var(--color-highlighter-color)",
                textTransform: "capitalize",
                borderRadius: 4
            }
        }

    const isLong = props.description?.length > 170

    return (
        <div className="body-s-semibold seemore__body" style={props.preLine ? { whiteSpace: 'pre-line' } : undefined}>
            <TextHighlighter
                contentString={showall ? props.description : props.short_description}
                toMatch={toMatch}
                isInline
            />
            {isLong && !showall && (
                <>
                    {' '}
                    <span
                        className="body-s-semibold cursor-pointer link-subtle"
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setShowall(true)
                        }}
                    >
                        Read more
                    </span>
                </>
            )}
            {isLong && showall && (
                <>
                    {' '}
                    <span
                        className="cursor-pointer link-subtle expanded"
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setShowall(false)
                        }}
                    >
                        Read less
                    </span>
                </>
            )}
        </div>
    )
}

export default Seemore